import InputBase, { inputBaseClasses } from '@mui/material/InputBase';
import { inputAdornmentClasses } from '@mui/material/InputAdornment';
import styled from '@emotion/styled';

export const StyledInput = styled(InputBase)`
    label + & {
        margin-top: 8px;
    }

    &.Mui-error {
        &.${inputBaseClasses.root},
            &.${inputBaseClasses.root}:focus,
            &.${inputBaseClasses.root}.${inputBaseClasses.focused} {
            border-color: ${(props) => props.theme.colors.error};
            box-shadow: none;
        }
    }

    & .${inputAdornmentClasses.positionStart} {
        margin-left: 8px;
        p {
            color: ${(props) => props.theme.colorsUnifications.gunmetal[100]};
            font-size: 16px;
        }
    }

    &.Mui-error.${inputBaseClasses.root}.${inputBaseClasses.adornedStart} {
        border-color: ${(props) => props.theme.colors.error};
    }

    &.${inputBaseClasses.root} {
        font-family: NotoSans, Helvetica, sans-serif;
        background-color: #fff;
        border-radius: 5px;
        border: 2px solid ${(props) => props.theme.colorsUnifications.whiteSmoke['100']};
    }

    &.${inputBaseClasses.root}:focus, &.${inputBaseClasses.root}.${inputBaseClasses.focused} {
        box-shadow: none;
        border-color: ${(props) => props.theme.colorsUnifications.azure['100']};
    }

    & .${inputBaseClasses.input} {
        position: relative;
        background-color: #fff;
        border-radius: 5px;
        padding: 13px 12px 13px 16px;
        /* should be 16px on mobile devices to prevent zoom issue */
        font-size: 16px;
        border: none;
        color: ${(props) => props.theme.colorsUnifications.gunmetal['100']};

        &.${inputBaseClasses.disabled} {
            background: ${(props) => props.theme.colorsUnifications.desertStorm['100']};
        }

        ${(props) => props.theme.media.smAndUp} {
            font-size: 14px;
        }
    }

    &.${inputBaseClasses.adornedStart} .${inputBaseClasses.input} {
        padding-left: 0;
    }

    & .${inputBaseClasses.input}::placeholder {
        color: ${(props) => props.theme.colorsUnifications.gunmetal['50']};
    }
`;
